"use strict";

var _classCallCheck = require("/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/classCallCheck.js").default;

var _createClass = require("/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/createClass.js").default;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.at.js");

require("core-js/modules/es.typed-array.copy-within.js");

require("core-js/modules/es.typed-array.every.js");

require("core-js/modules/es.typed-array.fill.js");

require("core-js/modules/es.typed-array.filter.js");

require("core-js/modules/es.typed-array.find.js");

require("core-js/modules/es.typed-array.find-index.js");

require("core-js/modules/es.typed-array.for-each.js");

require("core-js/modules/es.typed-array.includes.js");

require("core-js/modules/es.typed-array.index-of.js");

require("core-js/modules/es.typed-array.iterator.js");

require("core-js/modules/es.typed-array.join.js");

require("core-js/modules/es.typed-array.last-index-of.js");

require("core-js/modules/es.typed-array.map.js");

require("core-js/modules/es.typed-array.reduce.js");

require("core-js/modules/es.typed-array.reduce-right.js");

require("core-js/modules/es.typed-array.reverse.js");

require("core-js/modules/es.typed-array.set.js");

require("core-js/modules/es.typed-array.slice.js");

require("core-js/modules/es.typed-array.some.js");

require("core-js/modules/es.typed-array.sort.js");

require("core-js/modules/es.typed-array.subarray.js");

require("core-js/modules/es.typed-array.to-locale-string.js");

require("core-js/modules/es.typed-array.to-string.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextEncoder = void 0; // Copyright 2017-2022 @polkadot/x-textencoder authors & contributors
// SPDX-License-Identifier: Apache-2.0
// This is very limited, only handling Ascii values

var TextEncoder = /*#__PURE__*/function () {
  function TextEncoder() {
    _classCallCheck(this, TextEncoder);
  }

  _createClass(TextEncoder, [{
    key: "encode",
    value: function encode(value) {
      var u8a = new Uint8Array(value.length);

      for (var i = 0; i < value.length; i++) {
        u8a[i] = value.charCodeAt(i);
      }

      return u8a;
    }
  }]);

  return TextEncoder;
}();

exports.TextEncoder = TextEncoder;